import styled from 'styled-components'

import { EmptyState, Layout } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { mirandaSizes } from 'core/miranda-styles/screen'

import NoResultsIllustration from '../assets/no-results.svg'

const IllustrationWrapper = styled(EmptyState.Illustration)`
  @media (max-width: ${mirandaSizes.sm}) {
    display: none;
  }
`

const StyledLayoutStack = styled(Layout.Stack)`
  padding-top: ${getToken('spacing-20')};

  @media (max-width: ${mirandaSizes.sm}) {
    padding-top: ${getToken('spacing-6')};
  }
`

export function EmptyShipmentsListState() {
  return (
    <StyledLayoutStack align="center">
      <EmptyState variant="page">
        <IllustrationWrapper>
          <img src={NoResultsIllustration} role="presentation" width="190px" alt="" />
        </IllustrationWrapper>
        <EmptyState.Header>No shipments found</EmptyState.Header>
        <EmptyState.Message>Change the terms of your search and try again</EmptyState.Message>
      </EmptyState>
    </StyledLayoutStack>
  )
}
